import Icon from "@ant-design/icons";
import { enumNavigation } from "@configs";
import { IInfo, IMemberShipTiers } from "@interfaces";
import { setDetailUser } from "@redux";
import { Tabs } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import { ComponentNewHomeProductDrawer } from "./drawer/NewHomeProductDrawer";
import { ComponentOrderHistoryDrawer } from "./drawer/OrderHistory";
import { AddIcon } from "./icon/AddIcon";
import { CallIcon } from "./icon/CallIcon";
import { MapIcon } from "./icon/MapIcon";

interface IProps {
    themeColor: string;
    userInfo: IInfo | null;
    memberShipTiers: IMemberShipTiers[];
    under: enumNavigation;
    handleToggleUnder: (value: enumNavigation) => void;
    handleToggleQrCode: () => void;
    handleSwitchUserSetting: () => void;
    handleSwitchTier: () => void;
    // handleCoupon: () => void;
}

export const ComponentNewHome = (props: IProps) => {
    const history = useHistory();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [OrderHistoryDrawer, setOrderHistoryDrawer] = useState<boolean>(false);
    const [selectedService, setSelectedService] = useState<any>({});
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    //page variable
    const {
        themeColor,
        userInfo,

        under,
        handleToggleUnder,
        handleToggleQrCode,
        handleSwitchUserSetting,
        handleSwitchTier,
        // handleCoupon,
    } = props;

    const handleDetail = () => {
        dispatch(setDetailUser());
    };
    let [banner, setBanner] = useState([]);
    let [staff, setStaff] = useState([]);

    const [loading, setLoading] = useState(false);
    const [serviceLoading, setServiceLoading] = useState(false);
    const [ShowAllStores, setShowAllStores] = useState(false);
    const [ShowStoreDetails, setShowStoreDetails] = useState(false);

    // let [storeDetails, SetStoreDetails] = useState({});
    let [storeDetails, SetStoreDetails] = useState<any>({
        store_name: "",
        business_hours: {},
    });

    let [todayDay, setTodayDay] = useState({ is_active: null, open_hour: "", close_hour: "" });
    let [storeName, setStoreName] = useState(localStorage.getItem("store_code") || "");
    let localStoreCode = localStorage.getItem("store_code") || "";
    if (localStoreCode.length === 0) {
        setStoreName("store_a");
        localStorage.setItem("store_code", "store_a");
    }

    const loadStores = async () => {
        try {
            let loadStoreRes = await axios.get(
                `https://api-store.rocket-tech.app/1.0.0/chooseStoreFromList/?organization_code=T94&store_code=${storeName}`
            );
            SetStoreDetails(loadStoreRes.data.result[0]);
            setLoading(true);
            const todayDay = dayjs().format("dddd").toLowerCase();
            setTodayDay(storeDetails.business_hours[todayDay]);
            localStorage.setItem("store_code", storeName);
        } catch (err) {
            console.error(err);
        }
    };

    let [allStoreDetails, setAllStoreDetails] = useState([]);
    let [AllStoresLoading, setAllStoresLoading] = useState(false);
    const loadAllStores = async () => {
        try {
            let loadStoreRes = await axios.get(
                `https://api-store.rocket-tech.app/1.0.0/chooseStoreFromList/?organization_code=T94`
            );
            setAllStoreDetails(loadStoreRes.data.result);
            setAllStoresLoading(true);
        } catch (err) {
            console.error(err);
        }
    };

    const serviceLoad = async () => {
        try {
            let res = await axios.get("https://api-store.rocket-tech.app/1.0.0/ServicesSelection");
            if (serviceLoading !== true) {
                for (let i = 0; i < res.data.length; i++) {
                    let newBanner = res.data[i];
                    newBanner = banner;
                    newBanner.push({
                        cover: res.data[i].image_url_list[0].image_url,
                        title: res.data[i].service_name,
                        description: res.data[i].description,
                        price: res.data[i].standard_price,
                        service_code: res.data[i].service_code,
                    });
                    setBanner(newBanner);
                }
            }
            setServiceLoading(true);
        } catch (err) {
            console.error(err, "\nSomething wrong, try again!");
        }
    };
    useEffect(() => {
        loadAllStores();
    }, [AllStoresLoading]);
    useEffect(() => {
        loadStores();
    }, [loading]);
    useEffect(() => {
        serviceLoad();
    }, [serviceLoading]);

    useEffect(() => {
        axios
            .get("https://api-store.rocket-tech.app/1.0.0/staffSelection")
            .then((data) => {
                for (let i = 0; i < data.data.length; i++) {
                    let newStaff = data.data[i];
                    newStaff = staff;
                    newStaff.push({
                        cover: data.data[i].image_url,
                        name: data.data[i].name,
                        position: data.data[i].position,
                        staff_code: data.data[i].staff_code,
                    });
                    setStaff(newStaff);
                }
            })
            .catch((err) => console.error(err, "\nSomething wrong, try again!"));
    }, []);

    // get both services and staffs
    let [getBothLoading, setGetBothLoading] = useState(false);
    let [serviceExist, setServiceExist] = useState([]);
    let [staffExist, setStaffExist] = useState([]);
    const getBothServiceAndStaff = async () => {
        try {
            const res = await axios.get(
                `https://api-store-admin.rocket-tech.app/1.0.0/clientSite/getServiceAndStaffOnStore?organization_code=T94&store_code=${storeName}`
            );
            if (getBothLoading !== true) {
                for (let i = 0; i < res.data.result.service_list.length; i++) {
                    let newBanner = res.data.result.service_list[i];
                    newBanner = serviceExist;
                    newBanner.push({
                        cover: res.data.result.service_list[i].image_url_list[0].image_url,
                        title: res.data.result.service_list[i].service_name,
                        description: res.data.result.service_list[i].description,
                        price: res.data.result.service_list[i].standard_price,
                        service_code: res.data.result.service_list[i].service_code,
                    });
                    setServiceExist(newBanner);
                }
                for (let i = 0; i < res.data.result.staff_list.length; i++) {
                    let newStaff = res.data.result.staff_list[i];
                    newStaff = staffExist;
                    newStaff.push({
                        cover: res.data.result.staff_list[i].image_url,
                        name: res.data.result.staff_list[i].staff_name,
                        position: res.data.result.staff_list[i].position,
                        staff_code: res.data.result.staff_list[i].staff_code,
                    });
                    setStaffExist(newStaff);
                }
                setGetBothLoading(true);
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        getBothServiceAndStaff();
    }, [getBothLoading]);
    const { TabPane } = Tabs;

    return (
        <>
            <div className="SalonName preview fixBorderRadius">
                <div className="topSalonName">
                    <h1
                        onClick={() => {
                            setShowAllStores(true);
                        }}
                    >
                        After You Dessert pinklo
                        <Icon type="right" />
                    </h1>
                    <div className="topStoreInfo">
                        <MapIcon />
                        <div
                            onClick={() => {
                                setOrderHistoryDrawer(true);
                            }}
                        >
                            <CallIcon />
                        </div>
                    </div>
                </div>
                <div className="botSalonName">
                    <p>เวลาเปิดทำการ: 09.00 - 21.00 (จันทร์ - อาทิตย์)</p>
                </div>
            </div>
            <div className="popularSection">
                <h1 className="secondH1">
                    <span style={{ color: "#F22F46", fontWeight: "bold" }}>|</span> Popular
                </h1>
            </div>
            <div className="swiperSection">
                {banner.length !== 0 ? (
                    <Swiper
                        slidesPerView={2.5}
                        spaceBetween={20}
                        grabCursor={true}
                        className="mySwiper"
                    >
                        {serviceExist
                            ? serviceExist.map((item, i) => (
                                  <SwiperSlide
                                      onClick={() => {
                                          setShowModal(true);
                                          setSelectedService(item);
                                      }}
                                      key={i}
                                  >
                                      <img
                                          src={
                                              "https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg"
                                          }
                                      />
                                      <div className="ServiceTitle">
                                          <h1 className="topServiceTitle">{item["title"]}</h1>
                                      </div>
                                      <div className="priceAndArrow">
                                          <h2>
                                              {item["price"]}{" "}
                                              <span style={{ fontWeight: "normal" }}>฿</span>
                                          </h2>
                                          <AddIcon />
                                      </div>
                                  </SwiperSlide>
                              ))
                            : null}
                    </Swiper>
                ) : (
                    <p>Please refresh the page</p>
                )}
            </div>
            <div className="servicesSection">
                <Tabs defaultActiveKey="1" tabPosition={"left"}>
                    <TabPane tab="Dessert" key="1">
                        <div className="rightSide">
                            <div className="tab-content">
                                {serviceExist
                                    ? serviceExist.map((item, i) => (
                                          <div
                                              className="allServices"
                                              onClick={() => {
                                                  setShowModal(true);
                                                  setSelectedService(item);
                                              }}
                                              key={i}
                                          >
                                              <div className="coverImage">
                                                  <img
                                                      src={
                                                          "https://rewarding-rocket.s3.ap-southeast-1.amazonaws.com/1670923290711-267716281_4726838330709766_1134510568621344769_n.jpg"
                                                      }
                                                  />
                                              </div>
                                              <div className="serviceInfo">
                                                  <h1>{item["title"]}</h1>
                                                  <p>{item["description"]}</p>
                                                  <div className="priceAndArrow">
                                                      <h2>
                                                          {item["price"]}{" "}
                                                          <span
                                                              style={{
                                                                  fontWeight: "normal",
                                                              }}
                                                          >
                                                              ฿
                                                          </span>
                                                      </h2>
                                                      <AddIcon />
                                                  </div>
                                              </div>
                                          </div>
                                      ))
                                    : null}
                            </div>
                        </div>
                    </TabPane>
                    <TabPane tab="Beverage" key="2">
                        //
                    </TabPane>
                    <TabPane
                        tab={
                            <div>
                                Special
                                <br />
                                Season
                            </div>
                        }
                        key="3"
                    >
                        Content of Tab Pane 3
                    </TabPane>
                    <TabPane tab="Food" key="4">
                        Content of Tab Pane 3
                    </TabPane>
                    <TabPane tab="Organic" key="5">
                        Content of Tab Pane 3
                    </TabPane>
                </Tabs>
            </div>
            <ComponentNewHomeProductDrawer
                showModal={showModal}
                handleClose={() => setShowModal(!showModal)}
                selectedService={selectedService}
            />
            <ComponentOrderHistoryDrawer
                showModal={OrderHistoryDrawer}
                handleClose={() => setOrderHistoryDrawer(!OrderHistoryDrawer)}
                selectedService={selectedService}
            />
        </>
    );
};
